export function textSymbolLimit(text,limit){

    if(text.length>limit)
        return text.slice(0,limit)+'...';
    if(text.length<=limit)
        return text;
}